import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/env';
@Injectable({
  providedIn: 'root'
})
export class TermsService {
  private apiUrl = environment.BASE_URL + `/ptp/`;
  public header = { headers: { 'Access-Control-Allow-Origin': '*' } }
  constructor(private http: HttpClient) { }

  updateTermsandCondition(isTermsAccepted: boolean, userId:any): Observable<any[]> {
    return this.http.put<any[]>(this.apiUrl + `api/spp/mct/`+userId+`/terms/status?termsAndConditions=` + isTermsAccepted, this.header);
  }
}
